const clarity = (phone_number) => {
  if (window.clarity) {
    window.clarity('set', 'userId', phone_number);
  }
};

export default clarity;
